import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {SettlementService} from "../../services/settlement.service";
import {UserViewModel} from "../../models/user-view-model";

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  public reason: string = "";

  public HoldBy: string;
  public HoldByUser: UserViewModel;
  public HoldReason: string;
  public HoldAt: Date;
  public ReleaseBy: string;
  public ReleaseByUser: UserViewModel;
  public ReleaseReason: string;
  public ReleaseAt: Date;

  constructor(private modal: NgbActiveModal, private _settlementService: SettlementService) {
  }

  public async ngOnInit(): Promise<void> {
    if (this.HoldBy) {
      this.HoldByUser = await this._settlementService.GetUser(this.HoldBy);
    }
    if (this.ReleaseBy) {
      this.ReleaseByUser = await this._settlementService.GetUser(this.ReleaseBy);
    }
  }


  public close() {
    this.modal.close(null);
  }

}
